module.exports = __webpack_public_path__ + "img/P150T_weapon_155.ad96e72f.png";